import ProsecutorCard from 'components/card/ProsecutorCard';
import React from 'react';

interface ProsecutorAssignmentSectionProps {
  canAssignProsecutor: boolean;
  selectedProsecutor: string;
  prosecutors: any[];
  referral?: any;
  onProsecutorChange: (value: string) => void;
  onAssignReAssign: () => void;
}

export const ProsecutorAssignmentSection: React.FC<ProsecutorAssignmentSectionProps> = ({
  canAssignProsecutor,
  selectedProsecutor,
  prosecutors,
  referral,
  onProsecutorChange,
  onAssignReAssign,
}) => {
  if (!canAssignProsecutor) return null;

  return (
    <div className="bg-white shadow-md rounded-lg p-6 mt-4">
      <div className="flex items-center mb-4">
        <div className="icon-bg">
          <svg width="21" height="19" viewBox="0 0 21 19" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M11 15.5C11 12.19 13.69 9.5 17 9.5C18.1 9.5 19.12 9.8 20 10.31V2.5C20 1.96957 19.7893 1.46086 19.4142 1.08579C19.0391 0.710714 18.5304 0.5 18 0.5H2C0.89 0.5 0 1.39 0 2.5V14.5C0 15.0304 0.210714 15.5391 0.585786 15.9142C0.960859 16.2893 1.46957 16.5 2 16.5H11.09C11.04 16.17 11 15.84 11 15.5ZM2 4.5V2.5L10 7.5L18 2.5V4.5L10 9.5L2 4.5ZM18 18.5V16.5H14V14.5H18V12.5L21 15.5L18 18.5Z"
              fill="#212121"
            />
          </svg>
        </div>
        <div className="ml-4">
          <p className="referral-form-title">Prosecutor Reassignment</p>
          <p className="referral-form-description">
            Assign or reassign prosecutor for this case
          </p>
        </div>
      </div>

      <div className="space-y-4">
        <div className="flex flex-col">
          <label className="referral-popup-label">Select Here</label>
          <select
            className="referral-form-field"
            value={selectedProsecutor}
            onChange={(e) => onProsecutorChange(e.target.value)}
            required
          >
            <option value="">Select Prosecutor</option>
            {prosecutors?.map((pros) => (
              <option value={pros?.user?.id} key={pros?.user?.id}>
                {pros.user?.first_name} {pros.user?.last_name}
              </option>
            ))}
          </select>
        </div>

        {(referral?.assigned_prosecutor || selectedProsecutor) && (
          <ProsecutorCard 
            selectedProsecutor={selectedProsecutor}
            prosecutors={prosecutors}
            referral={referral}
          />
        )}

        <div className="flex justify-end">
          <button
            onClick={onAssignReAssign}
            className="referral-form-button text-white"
            style={{ padding: "10px 20px", fontSize: "14px" }}
          >
            Assign and Forward
          </button>
        </div>
      </div>
    </div>
  );
};

